import React, { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import FirmList from '../pages/firms/FirmList';
import RightArrowIcon from '../assets/chevron-down-svgrepo-com.svg';
import UserContext from '../context/UserContext';
import { useContext } from 'react';

const GET_MENUS = gql`
  query GetMenus($place: String, $lang: String, $type: String) {
    Tbl_Menu(where: { place: { _eq: $place }, lang: { _eq: $lang }, type: { _eq: $type } }) {
      id
      title
      slug
      icon
      type
      lang
      place
    }
    Tbl_Menu_Item(where: { lang: { _eq: $lang } }) {
      id
      menuId
      parentId
      title
      slug
      link
      lang
      hasChildren
    }
  }
`;

const Sidebar = () => {
  const [openMenus, setOpenMenus] = useState([]);
  const { users } = useContext(UserContext);
  const place = users.placeSide;
  const lang = users.userLang;
  const type = users.usertype;

  const { loading, error, data } = useQuery(GET_MENUS, {
    variables: { place, lang, type },
  });

  const toggleMenu = (menuId) => {
    if (openMenus.includes(menuId)) {
      setOpenMenus(openMenus.filter((id) => id !== menuId));
    } else {
      setOpenMenus([...openMenus, menuId]);
    }
  };

  if (loading) return <p>Loading Menu...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const menus = data.Tbl_Menu;
  const menuItems = data.Tbl_Menu_Item;

  const renderSubMenu = (menuId) => {
    const subMenuItems = menuItems.filter((item) => item.menuId === menuId && item.parentId !== null );

    if (subMenuItems.length === 0) return null;

    return (
      <ul className="pl-8 ">
        {subMenuItems.map((item) => (
          <li key={item.id}>
            <Link to={item.link} className="flex items-center space-x-2 p-1 text-sm text-gray-300 hover:text-violet-300">
              <span>{item.title}</span>
            </Link>
            {item.hasChildren && renderSubMenu(item.id)}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="flex h-screen ">
      <div className="bg-violet-950 text-white w-52 flex flex-col overflow-auto">
        <div className="h-4 flex items-center justify-center">
          
          
        </div>
        <div className="flex-1 flex flex-col justify-between cursor-pointer">
          <nav>
            <ul className="space-y-0 font-light text-sm  ">
              {menus.map((menu) => (
                <li key={menu.id}>
                  <Link
                    to={menu.link}
                    className="flex items-center space-y-1 space-x-1 p-3 font-normal text-sm  selection:text-purple-900 hover:text-violet-300"
                    onClick={() => toggleMenu(menu.id)}
                  >
                    <span className="flex items-center ">
                      <img src={menu.icon} alt={menu.title} className="mr-2 h-4 w-4  text-gray-300" />
                      <span>{menu.title}</span>
                    </span>
                    <span className="flex items-center ml-auto  ">
                      {openMenus.includes(menu.id) }
                  </span>
                </Link>
                {openMenus.includes(menu.id) && renderSubMenu(menu.id)}
              </li>
            ))}
          </ul>
        </nav>
        <div className="h-16 flex items-center justify-center">
          <span className="text-sm">Sterna@ Manila V1.1</span>
        </div>
      </div>
    </div>
  
  </div>
);
};

export default Sidebar;
